import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

export const signupText = 'Thank you for your interest. Your application has been received.';
export const ratingText = 'Thank you for your rating. Please click the header to submit another rating.';

export default function ConfirmationScreen(props) {
  let text = '';

  if (props.match.params.type === 'signup') text = signupText;
  else if (props.match.params.type === 'rating') text = ratingText;

  return (
    <React.Fragment>
      <Grid id="role-selection-grid" fluid>
        <Row id="role-selection-row">
          <Col xs={12} md={6} mdOffset={3} className="role-selection-col">
            <h4>{text}</h4>
          </Col>
        </Row>
      </Grid>

      <style jsx>{`
        h4 {
          text-align: center;
          border-bottom: 0;
          font-size: 18px;
          text-transform: unset;
        }
      `}</style>
    </React.Fragment>
  );
}
